import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './list.icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-536165bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-item is-flex is-relative is-justify-content-space-between rounded pr-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "is-hidden-mobile" }, [
  /*#__PURE__*/_createElementVNode("figure", { class: "image is-48x48 m-0 mr-6 ml-2" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "icon"
    })
  ])
], -1))
const _hoisted_3 = { class: "is-flex is-flex-direction-column" }
const _hoisted_4 = {
  class: "label mb-0",
  role: "heading"
}
const _hoisted_5 = ["title"]
const _hoisted_6 = {
  class: "buttons",
  role: "button"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SButton = _resolveComponent("SButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _mergeProps({ class: "is-flex is-align-items-center p-4 content-section" }, _ctx.$attrs), [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.title), 1),
        (_ctx.description)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "list-description has-text-weight-normal",
              role: "text",
              title: _ctx.description
            }, _toDisplayString(_ctx.abbreviatedDescription), 9, _hoisted_5))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ], 16),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.controlButtons, (controlButton) => {
      return (_openBlock(), _createElementBlock("section", {
        key: controlButton.iconClass,
        class: "is-flex is-align-items-center"
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_SButton, _mergeProps({ class: "button is-dark is-inverted" }, controlButton), null, 16)
        ])
      ]))
    }), 128))
  ]))
}